import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { CONNECTORS } from '../../services/connectors';
import { requestAccess } from '../../services/onboarding';
import { ChannelIcon } from './channelIcons';

export default function ComingSoonCatalog() {
  const soon = CONNECTORS.filter(c => c.status === 'soon');
  const [requested, setRequested] = useState<Set<string>>(new Set());

  const ask = async (id: string, name: string) => {
    setRequested(prev => new Set(prev).add(id));
    try { await requestAccess(id); toast.success(`We'll notify you about ${name}`); }
    catch { /* optimistic */ }
  };

  return (
    <div className="border border-dashed border-gray-200 rounded-xl p-4">
      <h3 className="text-sm font-semibold text-gray-900 mb-1">More lead sources</h3>
      <p className="text-xs text-gray-500 mb-3">Coming soon — request access and we'll prioritise by demand.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {soon.map(c => (
          <button key={c.id} onClick={() => ask(c.id, c.name)} disabled={requested.has(c.id)}
            className="flex items-center justify-between gap-2 text-left border border-gray-200 rounded-lg px-3 py-2 hover:bg-gray-50 disabled:opacity-60">
            <span className="flex items-center gap-2 min-w-0">
              <ChannelIcon id={c.id} className="w-4 h-4 flex-shrink-0" />
              <span className="text-xs font-medium text-gray-700 truncate">{c.name}</span>
            </span>
            <span className="text-[10px] text-blue-600 flex-shrink-0">{requested.has(c.id) ? '✓ Requested' : 'Request'}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
